import { useEffect, useState, useRef } from "react";

const StorySection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="story" className="story-section" ref={sectionRef} data-testid="story-section">
      <div className="story-grid">
        <div className={`story-content ${isVisible ? 'animate-slideInLeft' : 'opacity-0'}`}>
          <span className="story-label">Our Philosophy</span>
          <h2 className="story-title">Scent as an Experience</h2>
          <p className="story-text">
            At Interlude, we believe fragrance is the invisible thread that weaves through memory 
            and emotion. We partner with discerning hospitality brands to create olfactory 
            identities that transform spaces and leave lasting impressions on guests.
          </p>
          <p className="story-text">
            Our artisanal approach combines centuries-old perfumery traditions with modern 
            sensibilities, resulting in bespoke scent solutions tailored to your brand's 
            unique character and clientele.
          </p>

          <div className="fragrance-notes">
            <div className="note-item">
              <p className="note-label">Hotels</p>
              <p className="note-value">Lobbies & Suites</p>
            </div>
            <div className="note-item">
              <p className="note-label">Restaurants</p>
              <p className="note-value">Ambiance & Identity</p>
            </div>
            <div className="note-item">
              <p className="note-label">Cafés</p>
              <p className="note-value">Warmth & Welcome</p>
            </div>
          </div>
        </div>

        <div className={`story-image-container ${isVisible ? 'animate-slideInRight' : 'opacity-0'}`}>
          <img
            src="/images/hotel.png"
            alt="Elevate Your Space with Interlude's Signature Scents"
            className="story-image"
            data-testid="story-image"
          />
        </div>
      </div>
    </section>
  );
};

export default StorySection;
